import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { FileText, History, LogOut, Wrench, UserCircle2, Building2, Users } from "lucide-react";

export default function AppLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="app-bg grain min-h-screen relative z-10">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-slate-950/70 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-amber-500 flex items-center justify-center shadow-lg">
              <Wrench size={18} className="text-white"/>
            </div>
            <div>
              <div className="font-display font-bold text-lg leading-tight">FakturaFlow <span className="text-amber-400">ZUGFeRD</span></div>
              <div className="text-[10px] font-mono tracking-wider text-slate-500 uppercase">freewarefaktura · HEY EDITION BY YZ</div>
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-1">
            <NavLink to="/app/convert" data-testid="nav-convert" className={({isActive}) => `px-4 py-2 rounded-lg text-sm font-medium transition ${isActive ? "bg-blue-600/15 text-blue-300 border border-blue-500/30" : "text-slate-300 hover:bg-slate-800/50"}`}>
              <FileText size={14} className="inline mr-1.5"/> Rechnung konvertieren
            </NavLink>
            <NavLink to="/app/dashboard" data-testid="nav-history" className={({isActive}) => `px-4 py-2 rounded-lg text-sm font-medium transition ${isActive ? "bg-blue-600/15 text-blue-300 border border-blue-500/30" : "text-slate-300 hover:bg-slate-800/50"}`}>
              <History size={14} className="inline mr-1.5"/> Historie
            </NavLink>
            <NavLink to="/app/profile" data-testid="nav-profile" className={({isActive}) => `px-4 py-2 rounded-lg text-sm font-medium transition ${isActive ? "bg-blue-600/15 text-blue-300 border border-blue-500/30" : "text-slate-300 hover:bg-slate-800/50"}`}>
              <Building2 size={14} className="inline mr-1.5"/> Stammdaten
            </NavLink>
            {user?.role === "admin" && (
              <NavLink to="/app/admin/users" data-testid="nav-admin-users" className={({isActive}) => `px-4 py-2 rounded-lg text-sm font-medium transition ${isActive ? "bg-amber-500/15 text-amber-300 border border-amber-500/30" : "text-slate-300 hover:bg-slate-800/50"}`}>
                <Users size={14} className="inline mr-1.5"/> Benutzer
              </NavLink>
            )}
          </nav>

          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-2 text-sm text-slate-300" data-testid="user-chip">
              <UserCircle2 size={18} className="text-slate-400"/>
              <span className="font-medium">{user?.name || user?.email}</span>
            </div>
            <button className="btn-ghost" onClick={async () => { await logout(); nav("/login"); }} data-testid="logout-button">
              <LogOut size={14}/> Abmelden
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        <Outlet/>
      </main>

      <footer className="max-w-7xl mx-auto px-6 py-10 text-center text-xs font-mono text-slate-500 tracking-wider">
        EN 16931 · ZUGFeRD 2.5 · Factur-X · XRechnung 3.0 · GoBD-konform
      </footer>
    </div>
  );
}
